import { TransformControlsMode } from '@fabric-web/3d-viewer';

export const transformModeToString = (
  transformMode: TransformControlsMode | undefined
): 'translate' | 'rotate' | 'scale' | undefined => {
  switch (transformMode) {
    case TransformControlsMode.Translate:
      return 'translate';
    case TransformControlsMode.Rotate:
      return 'rotate';
    case TransformControlsMode.Scale:
      return 'scale';
    default:
      return undefined;
  }
};

/**
 * Triggers a file download in the browser with the specified content and filename.
 * @param content The content of the file (string or any data that can be stringified).
 * @param fileName The desired name for the downloaded file (e.g., "mydata.json").
 * @param contentType The MIME type of the file content (e.g., "application/json", "text/plain").
 */
export const triggerFileDownload = (
  content: string | object,
  fileName: string,
  contentType: string
) => {
  const fileContent = typeof content === 'object' ? JSON.stringify(content, null, 2) : content;

  const blob = new Blob([fileContent], { type: contentType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
